import { createModule, mutation, action } from "vuex-class-component";
import api from "@/plugins/api";
import Game from "@/domain/game";

const VuexModule = createModule({
  namespaced: "games",
  strict: false,
  target: "nuxt"
});

export default class GamesStore extends VuexModule {
  db: { [id: string]: Game } = {};

  @mutation setGame(game: Game) {
    this.db[game.id] = game;
  }

  @action async loadGame(id: string) {
    const res = await api.get(`/v3/play/${id}?format=2`);
    this.setGame(new Game(res.data.id, res.data));
  }
}
